import { ActionButtonProps, Box, BoxProps, ColorOptions, Form, Spacer } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { FC, useEffect, useState } from 'react'
import { Dropdown } from '../../components/Dropdown'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { statusData } from '../../utils/constants'
import { editForm } from './editForm'

interface NbFormProps {
  nbMapping: any
  onUpdate: () => void
  isDeletable: boolean
  onClose: () => void
}
const NbForm: FC<NbFormProps> = (props: NbFormProps) => {
  const { onUpdate, nbMapping, isDeletable, onClose } = props
  const { id, entityID, status, bankName, rpslCode, entityCode } = nbMapping
  const [value, setValue] = useState(status)
  console.log({ id })
  const { updateNB, deleteNB, message } = useStores((store) => ({
    updateNB: store.netBanking.updateNB,
    deleteNB: store.netBanking.deleteNB,
    message: store.message.getFormMessage(),
  }))

  const [lazyUpdate, lazyUpdateHandler] = useLazyApiData(updateNB)
  const [lazyDelete, lazyDeleteHandler] = useLazyApiData(deleteNB)

  const [toggle, setToggle] = useState(false)
  const onDelete = () => {
    lazyDelete(entityID, id)
  }

  const onDismiss = () => {
    setToggle(false)
  }

  const deleteMapping = () => {
    console.log('delete')
    setToggle(true)
  }

  const updateMapping = (values: any) => {
    console.log('update')
    lazyUpdate({
      id,
      entityID,
      status: value === 'Enabled' ? 'true' : 'false',
      bankName: values.bankName,
      rpslCode: values.rpslCode,
      entityCode: values.entityCode,
    })
  }

  useEffect(() => {
    if (lazyUpdateHandler.state === 'fulfilled') {
      onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyUpdateHandler])

  useEffect(() => {
    if (lazyDeleteHandler.state === 'fulfilled') {
      setToggle(false)
      onUpdate()
    }
    if (lazyDeleteHandler.state === 'rejected') {
      setToggle(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyDeleteHandler])

  const handleActions = ({ values, title, defaultActionButtonOnSubmit }: ActionButtonProps) => {
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box flexDirection="row" align={'flex-end'} flexWrap={'wrap'}>
        <ModalAlertView
          onPress={onDelete}
          show={toggle}
          onDismiss={onDismiss}
          onCancel={onDismiss}
          title="Delete Card Mapping"
          buttonTitle="Delete"
          message={`Is this final. This will delete mapping with ID ${id} and Entity Id ${entityID}.`}
          isLoading={lazyDeleteHandler.state === 'pending'}
        />
        <Box w={200} pv={8}>
          <Dropdown
            data={statusData}
            title={status === 'Enabled' ? 'Enable' : 'Disable'}
            label={'Status'}
            selectedData={setValue}
          />
        </Box>
        <Spacer direction={'horizontal'} size={16} />

        <Box justify={'space-between'} flexDirection={'row'} flexGrow={1}>
          <ButtonNew
            title={'Update Mapping'}
            onPress={handleOnPress}
            height={36}
            color={'YELLOW'}
            hoverColor={'YELLOW'}
            textType={'body14'}
            paddingVertical={8}
            borderRadius={4}
            isLoading={lazyUpdateHandler.state === 'pending'}
          />
          <Spacer direction="horizontal" size={16} />
          {isDeletable && id && (
            <ButtonNew
              borderRadius={4}
              title={'Delete Mapping'}
              onPress={deleteMapping}
              height={36}
              color={'RED'}
              hoverColor={'RED'}
              textType={'body14'}
              paddingVertical={8}
              isLoading={lazyDeleteHandler.state === 'pending'}
            />
          )}
        </Box>
      </Box>
    )
  }

  const getInitialData = () => {
    return {
      entityCode: entityCode,
      rpslCode: rpslCode,
      bankName: bankName,
      status: status === 'Enabled' ? 'Enable' : 'Disable',
    }
  }

  const FormBox = ({ children }: any) => {
    return <Box {...styles.formContainer}>{children}</Box>
  }

  return (
    <Box>
      <Form
        initialValues={getInitialData()}
        formData={editForm(updateMapping, message)}
        actionButtons={handleActions}
        container={FormBox}
      />
    </Box>
  )
}

export { NbForm }

const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    bg: '#0000001f' as ColorOptions,
    minHeight: 220,
    pv: 16,
    ph: 20,
  } as BoxProps,
}
